module.exports = __webpack_public_path__ + "static/media/phone.ec390ddf.jpg";